import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import HorizontalScrollList from "../HorizontalScrollList";
import styles from "./RelatedCategories.scss";

export default function RelatedCategories() {
  const { relatedCategories, getTranslation } = useRuntimeConstants();

  if (!relatedCategories || relatedCategories.length === 0) {
    return null;
  }

  return (
    <div className={styles.section}>
      <div className={styles.subContainer}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {getTranslation("pdp_related_categories_title")}
          </h2>
        </div>

        <HorizontalScrollList>
          {relatedCategories.map((category) => (
            <li key={category.id}>
              <a href={category.linkUrl} className={styles.pill}>
                {category.friendlyName}
              </a>
            </li>
          ))}
        </HorizontalScrollList>
      </div>
    </div>
  );
}
